import * as yup from 'yup'
import { REQUIRED_FIELD } from 'constants/errors'
import { paymentDays } from 'constants/paymentDay'

export const schemaSchedulePaymentDay = yup.object().shape({
  paymentDay: yup.string().oneOf(paymentDays, REQUIRED_FIELD).required(REQUIRED_FIELD),
})
